import config from '@/config'
import { AxiosRequestConfig } from 'axios'
import { requestsV2 } from '.'

interface UploadAttachmentParams {
  locationId: string
  file: File
  documentId: string
  attemptId: string
  onUploadProgress: (progressEvent: any) => void
  cancelToken: any
}

export const AttachmentService = {
  uploadAttachment: ({
    locationId,
    file,
    documentId,
    attemptId,
    onUploadProgress,
    cancelToken,
  }: UploadAttachmentParams) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('attemptId', attemptId)

    const axiosConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
      cancelToken,
    }

    const filename = file.name.replace('&', '').replace('?', '')
    return requestsV2(config.PROPOSAL_SERVICE_URL).post(
      `/attachments/${locationId}/upload?documentId=${documentId}&fileName=${filename}`,
      formData,
      axiosConfig
    )
  },
}
